import React from 'react';
import { DomainNs } from 'ReactApp/Types/DomainNs';
import { observer } from "mobx-react";
import CartProductCardFavoriteV1 from 'ReactApp/Components/CartProductCardFavoriteV1/CartProductCardFavoriteV1';
import CartProductCardUnmarkAsDeletedV1 from '../CartProductCardUnmarkAsDeletedV1/CartProductCardUnmarkAsDeletedV1';
import IconV1 from '../IconV1/IconV1';
import { showableCartInstance } from 'ReactApp/Ddd/Aggregates/ShowableCart';
import { ProductTypeEnum } from 'ReactApp/Types/enum';

type RemoveShimV1Props = {
    card: DomainNs.ProductCardV6Interface,
    cardIndex: number,
}

const RemoveShimV1 = observer((props: RemoveShimV1Props) => {

    const removeHandler = (e: React.MouseEvent<HTMLElement>) => {
        showableCartInstance.deleteCardByIndex(props.cardIndex);
    }

    return (
        <div className={
            `remove-shim`
            + (!props.card.cartInfo.isDeleted ? ' _hide' : '')
        }>
            <p className="remove-shim__text"> 
                Вы удалили&nbsp;
                <span className="_bold">
                    {
                        (props.card.title as string)
                            +
                        (
                            props.card.currentRealModifier !== undefined && (
                                (` ${props.card.currentRealModifier.label}`)
                            )
                        )
                    }
                </span>
            </p>
            <div className="remove-shim__btn-wrap">
                <CartProductCardFavoriteV1 {...{
                    card: props.card,
                    cardIndex: props.cardIndex,
                    classes: [
                        'remove-shim__favorite',
                        'favorite-btn',
                        'add-to-wishlist-v1'
                    ],
                    attrs: {
                        'add-to-wishlist-v1': 1,
                        'data-add-to-wishlist-v1-is-in-wishlist': 
                            props.card.favoriteInfo.status ? 1 : 0,
                        'data-add-to-wishlist-v1-product-type-id':
                            ProductTypeEnum.realModifier,
                        'data-add-to-wishlist-v1-id':
                            props.card.realModifierId,
                        'data-add-to-wishlist-v1-virtual-modifier-id':
                            props.card.virtualModifierId,
                    },
                    label: (
                        (props.card.favoriteInfo.status === true)
                            ? 'В избранном' 
                            : 'В избранное'
                    )
                }} />
                <CartProductCardUnmarkAsDeletedV1 {...{
                    card: props.card,
                    classes: [
                        'remove-shim__return',
                    ],
                    label: 'Вернуть'
                }} />
            </div>
            <button 
                onClick={removeHandler}
                className="remove-shim__close js-destroy-element" 
                type="button"
                >
                <IconV1 {...{
                    svgSpriteId: 'close',
                    width: 18,
                    height: 18,
                    classes: [
                        'link-with-icon-v1__icon',
                        'remove-shim__close-icon',
                    ]
                }} />
            </button>
        </div>
    );

})

export default RemoveShimV1;